import { h, JSX } from "preact"
import { classJoin } from "../helpers/classjoin"
import { SliderMarks } from "./AbstractSlider"

/**
 * @group Components
 */
export interface StepsProps {
    min: number
    max: number
    step: number
    lowerBound: number
    upperBound: number
    marks: SliderMarks
    dots: boolean
    included: boolean
    vertical: boolean
    classesPrefix: string
}

/**
 * Dots on the slider.
 *
 * @group Components
 */
export function Steps({
    min,
    max,
    step,
    lowerBound,
    upperBound,
    marks,
    dots,
    included,
    vertical,
    classesPrefix
}: StepsProps) {
    const range = max - min

    const elements = calcPoints(marks, dots, step, min, max).map(point => {
        const offset = `${(Math.abs(point - min) / range) * 100}%`
        const style: JSX.CSSProperties = vertical ? { bottom: offset } : { left: offset }
        const active = (!included && point === upperBound) || (included && point <= upperBound && point >= lowerBound)

        const classes = classJoin({ active, dot: true }, cl => `${classesPrefix}${cl}`)

        return <span class={classes} style={style} key={String(point)} />
    })

    return <div class={`${classesPrefix}steps`}>{elements}</div>
}

/**
 * Calc slider points.
 */
function calcPoints(marks: SliderMarks, dots: boolean, step: number, min: number, max: number): number[] {
    const points = Object.keys(marks).map(Number)

    if (dots && step > 0) {
        for (let i = min; i <= max; i = i + step) {
            if (points.indexOf(i) === -1) {
                points.push(i)
            }
        }
    }

    return points
}
